import React, { Component } from 'react';

class Socialicons extends Component {
  render() {
    const showEmail = this.props.email !== undefined ? true : false;
    return (
      <div>
          <p className="social-icons">
              { showEmail && <a className="email-big" href="mailto:info@anywaysnyc.com"></a>}
              <a className="fb" href="https://www.facebook.com/anywaysnyc" target="_blank"></a>
              <a className="vimeo" href="https://vimeo.com/anywaysnyc" target="_blank"></a>
              <a className="tw" href="https://twitter.com/anywaysnyc" target="_blank"></a>
              <a className="ig" href="https://www.instagram.com/anywaysnyc/" target="_blank"></a>
          </p>
      </div>
    );
  }
}

export default Socialicons;



// WEBPACK FOOTER //
// ./src/components/All/Socialicons.js